export class Validator {
    @addError('EXPRESS_APPLICATION_REQUIRED_FIELD')
    static isNotEmpty(value) {
        return typeof value === 'string' ? !!value.trim() : !!value;
    }

    @addError('EXPRESS_APPLICATION_MORE_2_CHAR_FIELD')
    static isMoreTwo(value) {
        value = value.trim();

        return value.length > 2;
    }

    @addError('EXPRESS_APPLICATION_EMAIL_ADDRESS_ERROR')
    static email(value) {
        value = value.trim();
        if (!value) {
            return true;
        }
        // eslint-disable-next-line no-useless-escape
        const regExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        return regExp.test(value);
    }

    @addError('CAREER_MODAL_FILE_SIZE_ERROR')
    static fileSize(value) {
        if (value && value.size) {
            return value.size <= 2000000;
        }
        return true;
    }

    @addError('CAREER_MODAL_FILE_TYPE_ERROR')
    static fileType(value) {
        if (value && value.name) {
            const types = ['.jpeg', '.jpg', '.png', '.pdf', '.doc', '.docx', '.rtf'];
            const reverseName = value.name
                .split('')
                .reverse()
                .join('');
            const dotIndex = reverseName.indexOf('.');
            const fileType = reverseName
                .slice(0, dotIndex + 1)
                .split('')
                .reverse()
                .join('');
            for (const allowedType of types) {
                if (fileType.toLowerCase() === allowedType) {
                    return true;
                }
            }
            return false;
        }
        return true;
    }

    @addError('EXPRESS_APPLICATION_PHONE_NUMBER_ERROR')
    static phone(value) {
        value = value.trim();
        const regExp = /\+38 \([0-9]{3}\) [\d]{3} [\d]{2} [\d]{2}$/g;
        return regExp.test(value);
    }

    static validate(obj) {
        obj.isValid = true;
        obj.errors = [];
        for (const item in obj.validates) {
            if (typeof obj.validates[item] === 'function' && !obj.validates[item](obj.value)) {
                obj.isValid = false;
                obj.errors.push(obj.validates[item].displayError);
            }
        }

        return true;
    }
}

export function addError(error) {
    return (someClass, name, fn) => {
        fn.value.displayError = error;
    };
}
